import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Checkbox, Form, Input } from "antd";
import { Link } from "react-router-dom";
import { getErrorProps } from "@utils/helpers";
import { ButtonComponent, InputText } from "@comps/components";
import { signinUser } from "../authSlice";
import AuthLayout from "./AuthLayout";
import "./auth.css";

let credentials = {};

const SignIn = () => {
  const dispatch = useDispatch();
  /*
   * The busy state is read straight off the slice rather than mirrored
   * into local state: the copy was refreshed by an effect keyed on
   * `errors`, so a failed login that returned the same message left the
   * button spinning, and the pending action cleared it before the
   * request had even gone out.
   */
  const { loaderState, errors } = useSelector((state) => state.auth);

  const handleLoginSubmit = (data) => {
    credentials.email = data.email;
    credentials.password = data.password;
    dispatch(signinUser(credentials))
  }

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Welcome back! Please enter your details."
    >
      <Form
        className="auth-form"
        layout="vertical"
        name="basic"
        requiredMark={ false }
        initialValues={ { remember: false } }
        onFinish={ handleLoginSubmit }
      >
        {/* Why the sign-in was refused — wrong password, a deactivated
            account, too many attempts. All of them are about the attempt
            rather than about the email box they used to appear under. */ }
        { errors['form'] &&
          <Alert
            style={ { marginBottom: 20 } }
            type="error"
            showIcon
            message={ errors['form'] }
          /> }

        <Form.Item
          name="email"
          rules={ [
            { required: true, message: "Please input your email!" },
            { type: 'email', message: "Please enter a valid email address." },
          ] }
          label="Email"
          { ...getErrorProps(errors['email']) }
        >
          <InputText
            placeholder="Enter your email"
            autoComplete="email"
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={ [
            { required: true, message: 'Please input your password!', },
            { min: 6, message: 'Minimum password length is 6', },
            { max: 30, message: 'Maximum password length is 30', },
          ] }
          label="Password"
          { ...getErrorProps(errors['password']) }
        >
          <Input.Password
            placeholder="••••••••"
            autoComplete="current-password"
          />
        </Form.Item>

        <div className="auth-row">
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>Remember for 30 days</Checkbox>
          </Form.Item>

          <Link className="auth-link" to="/forgot-password">Forgot password</Link>
        </div>

        <Form.Item className="da-mb-0">
          <ButtonComponent className="actionButton" type="primary" htmlType="submit" state={ loaderState }>
            Sign in
          </ButtonComponent>
        </Form.Item>
      </Form>
    </AuthLayout>
  );
};

export default SignIn;
